import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';

const PhotosCircleButton = ({
  iconName,
  className,
  isFavorite,
  tooltip,
  ...props
}) => (
  <button className={[isFavorite ? 'UxCommon_PhotosCircleButtonF' : 'UxCommon_PhotosCircleButton', className || ''].join(' ')} {...props}>
    <Icon iconName={iconName} />
    {tooltip && <span className="Photo_Btn_tooltip">{tooltip}</span>}
  </button>
);
PhotosCircleButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  className: PropTypes.string,
  isFavorite: PropTypes.bool,
};

export default PhotosCircleButton;
